import { FormValidationRule } from "../types";

const isValidEmail = (email: string, isRequired: boolean) => {
    // https://emailregex.com/
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = re.test(email);

    return isRequired ? isValid : isValid || email === "";
};

const isEmailControl = (c: { [key: string]: any }) =>
    c.type === "email" || c.field_boi_text_as_email || c.isEmail;

const validateMultiInput: FormValidationRule = (c, v) => {
    const values: string[] = Object.values(v);
    const valid = isValidEmail(values[0], c.isRequired);
    const match = values[0] === values[1];
    return [
        valid && match,
        c.errorMessage ||
            (valid && !match
                ? "The email addresses entered do not match."
                : "You've entered an invalid email address.")
    ];
};

const validateSingleInput: FormValidationRule = (c, v) => [
    isValidEmail(v, c.isRequired),
    c.errorMessage || "You've entered an invalid email address."
];

const emailAddress: FormValidationRule = (c, v) => {
    if (isEmailControl(c) && v) {
        return c.inputs ? validateMultiInput(c, v) : validateSingleInput(c, v);
    } else {
        return [true, ""];
    }
};

export default emailAddress;
